import { languageNames, supportedLanguages } from 'utils';

// all choices available throughout the app
const booleanGeneric = [
  {
    id: true,
    name: 'choices.generic.boolean.true',
  },
  {
    id: false,
    name: 'choices.generic.boolean.false',
  },
];

const booleanInteger = [
  {
    id: 1,
    name: 'choices.generic.boolean.true',
  },
  {
    id: 0,
    name: 'choices.generic.boolean.false',
  },
];

const adminRoleType = [
  {
    id: 'SUPER_ADMIN',
    name: 'choices.admin.role.super_admin',
  },
  {
    id: 'ADMIN',
    name: 'choices.admin.role.admin',
  },
  {
    id: 'EVENT_DIRECTOR',
    name: 'choices.admin.role.event_director',
  },
];

const evidenceType = [
  {
    id: 'POLICE_MANILLA_FOLDER',
    name: 'choices.evidence.type.police_folder',
  },
  {
    id: 'LETTER_OPEN_ENVELOPE',
    name: 'choices.evidence.type.letter',
  },
  {
    id: 'ARTICLE_PAGE_OPEN',
    name: 'choices.evidence.type.article',
  },
  {
    id: 'DEVICE_PHONE_UNLOCK',
    name: 'choices.evidence.type.device',
  },
  {
    id: 'BOOK_OPEN',
    name: 'choices.evidence.type.book',
  },
];

const status = [
  {
    id: 'DRAFT',
    name: 'choices.status.draft',
  },
  {
    id: 'PUBLISHED',
    name: 'choices.status.published',
  },
];

const eventStatus = [
  {
    id: 'DRAFT',
    name: 'choices.eventStatus.draft',
  },
  {
    id: 'DIGITICKETS_DRAFT',
    name: 'choices.eventStatus.digiticketsDraft',
  },
  {
    id: 'PUBLISHED',
    name: 'choices.eventStatus.published',
  },
  {
    id: 'COMPLETED',
    name: 'choices.eventStatus.completed',
  }, 
];

const eventFilterStatus = [
  {
    id: 'ALL_ACTIVE',
    name: 'choices.eventStatus.allActive'
  },
  {
    id: 'DRAFT',
    name: 'choices.eventStatus.draft',
  },
  {
    id: 'DIGITICKETS_DRAFT',
    name: 'choices.eventStatus.digiticketsDraft',
  },
  {
    id: 'PUBLISHED',
    name: 'choices.eventStatus.published',
  },
  {
    id: 'COMPLETED',
    name: 'choices.eventStatus.completed',
  }, 
];

const rating = [
  {
    id: 1,
    name: '1',
  },
  {
    id: 2,
    name: '2',
  },
  {
    id: 3,
    name: '3',
  },
  {
    id: 4,
    name: '4',
  },
  {
    id: 5,
    name: '5',
  }
]

const dateRange = [
  {
    id: 'THISMONTH',
    name: 'choices.dateRange.thisMonth',
  },
  {
    id: 'LASTMONTH',
    name: 'choices.dateRange.lastMonth',
  },
  {
    id: 'THISYEAR',
    name: 'choices.dateRange.thisYear',
  },
  {
    id: 'LASTYEAR',
    name: 'choices.dateRange.lastYear',
  },
  {
    id: 'LAST_SEVEN_DAYS',
    name: 'choices.dateRange.lastSevenDays',
  },
  {
    id: 'LAST_THIRTY_DAYS',
    name: 'choices.dateRange.lastThirtyDyas',
  },
];

const uploadChoice = [
  {
    id: 'EDITOR',
    name: 'choices.evidence.uploadChoice.editor'
  },
  {
    id: 'PDF',
    name: 'choices.evidence.uploadChoice.pdf'
  },
  {
    id: 'VIDEO',
    name: 'Video'
  },
  {
    id: 'IMAGE',
    name: 'choices.evidence.uploadChoice.image'
  }
]

const evidenceNumber = [
  {
    id: 2,
    name: '2',
  },
  {
    id: 3,
    name: '3',
  },
  {
    id: 4,
    name: '4',
  },
  {
    id: 5,
    name: '5',
  },
  {
    id: 6,
    name: '6',
  },
  {
    id: 7,
    name: '7',
  },
  {
    id: 8,
    name: '8',
  },
  {
    id: 9,
    name: '9',
  },
  {
    id: 10,
    name: '10',
  }
];

const evidenceUnlockChoices = [
  {
    id: 'silver-lock',
    name: 'Silver Lock',
  },
  {
    id: 'golden-lock',
    name: 'Golden Lock',
  },
  {
    id: 'phone-lock',
    name: 'Phone Lock',
  },
  {
    id: 'safe-lock',
    name: 'Safe Lock',
  },
  {
    id: 'door-lock',
    name: 'Door Lock',
  },
  {
    id: 'suitcase-lock',
    name: 'Suitcase Lock',
  },
  {
    id: 'silhouette-target',
    name: 'Silhouette Target',
  },
  {
    id: 'chalk-outline',
    name: 'Chalk Outline',
  },
  {
    id: 'bookshelf',
    name: 'Bookshelf',
  },
  {
    id: 'typewriter',
    name: 'Typewriter',
  }
];
const enLanguageNames = languageNames();

const isoLanguage = supportedLanguages.map((language) => {
  return { id: language, name: enLanguageNames.of(language) };
});

export {
  adminRoleType,
  booleanGeneric,
  isoLanguage,
  evidenceType,
  status,
  eventStatus,
  eventFilterStatus,
  uploadChoice,
  rating,
  dateRange,
  evidenceNumber,
  booleanInteger,
  evidenceUnlockChoices
};
